import { render, staticRenderFns } from "./PcIdxNumWmContent.vue?vue&type=template&id=153871ce&"
import script from "./PcIdxNumWmContent.vue?vue&type=script&lang=js&"
export * from "./PcIdxNumWmContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports